/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FilterConditionDto } from './FilterConditionDto';

export type DataProductFilterConditionDto = (FilterConditionDto & {
    dataProductIds?: Array<string>;
    operator?: DataProductFilterConditionDto.operator;
} & {
    dataProductIds: Array<string>;
    operator: DataProductFilterConditionDto.operator;
});

export namespace DataProductFilterConditionDto {

    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
